import { render, staticRenderFns } from "./BloodPressureShowCreateEdit.vue?vue&type=template&id=4c557f32&scoped=true&"
import script from "./BloodPressureShowCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BloodPressureShowCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c557f32",
  null
  
)

export default component.exports